/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { RssFeed } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React, { useState } from "react";
import PopperBlock from "./PopperBlock";
import { useCloud } from "../Hooks/Cloud";

/**
 * Subscribe button popper
 * Description: This component is used to display the subscribe button popper
 */
function SubscribeButtonPopper() {
  const { cloud } = useCloud();
  const [ open, setOpen ] = React.useState(false);
  const [ anchorEl, setAnchorEl ] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? "subscribe-popper" : undefined;
  const features = window.ENV[cloud].features;

  if (!features.subscribe) {
    return <></>;
  }

  return (
    <>
      <Button
        aria-describedby={ id }
        variant="contained"
        onClick={ handleClick }
        disableElevation
      >
        <Typography
          component="span"
          variant="body2"
        >
          <RssFeed fontSize="small" />
        </Typography>
        <Typography component={ "span" } variant="body2">
          &nbsp;Subscribe To Updates
        </Typography>
      </Button>

      { /* Render popper block */ }
      <PopperBlock
        id={ id }
        open={ open }
        setOpen={ setOpen }
        anchorEl={ anchorEl }
      />
    </>
  );
}

export default SubscribeButtonPopper;
